import { makeStyles, shorthands } from '@fluentui/react-components';

export const useUnassignedIncidentsBarStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(255,203,5,0.04)',
    ...shorthands.borderTop('2px', 'solid', 'rgba(255,203,5,0.4)'),
    ...shorthands.borderBottom('2px', 'solid', 'rgba(255,203,5,0.4)'),
    ...shorthands.borderRadius('4px'),
    marginBottom: '18px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding('10px', '16px'),
    backgroundColor: 'rgba(255,203,5,0.08)',
  },
  headerTitle: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: '24px',
    fontWeight: 700,
    color: '#ffcb05',
    letterSpacing: '2px',
    textTransform: 'uppercase',
  },
  headerCount: {
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: '24px',
    color: '#ffcb05',
    lineHeight: 1,
  },
  listWrapper: {
    position: 'relative',
    display: 'flex',
    ...shorthands.overflow('hidden'),
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    height: '52px', // Single row
    ...shorthands.gap('8px'),
    ...shorthands.padding('14px', '16px', '25px', '16px'),
    ...shorthands.overflow('hidden'),
  },
  moreIndicatorRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...shorthands.padding('0', '16px'),
    backgroundColor: 'rgba(255,203,5,0.06)',
    ...shorthands.borderLeft('1px', 'solid', 'rgba(255,203,5,0.2)'),
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: '14px',
    color: '#ffcb05',
    letterSpacing: '1px',
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
  },
  card: {
    flexShrink: 0,
    flexGrow: 0,
    width: '220px',
    height: '52px',
    backgroundColor: 'rgba(255,255,255,0.03)',
    ...shorthands.borderLeft('3px', 'solid', '#ffcb05'),
    ...shorthands.padding('8px', '12px'),
    ...shorthands.borderRadius('3px'),
  },
  cardHighSeverity: {
    ...shorthands.borderLeft('3px', 'solid', '#e8394a'),
    backgroundColor: 'rgba(232,57,74,0.06)',
  },
  cardMediumSeverity: {
    ...shorthands.borderLeft('3px', 'solid', '#ffcb05'),
    backgroundColor: 'rgba(255,203,5,0.04)',
  },
  cardLowSeverity: {
    ...shorthands.borderLeft('3px', 'solid', '#8dc63f'),
    backgroundColor: 'rgba(141,198,63,0.03)',
  },
  cardTitle: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#deeaea',
    lineHeight: 1.2,
    marginBottom: '6px',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardSla: {
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: '18px',
    letterSpacing: '1px',
    lineHeight: 1,
  },
  cardSeverityBadge: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    ...shorthands.padding('2px', '8px'),
    ...shorthands.borderRadius('2px'),
  },
  emptyMessage: {
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: '14px',
    color: 'rgba(222,234,234,0.5)',
    ...shorthands.padding('8px', '16px'),
  },
});
